import windowsUpdatesService from '../services/WindowsUpdatesService';
import useSwr, { KeyedMutator } from 'swr';
import { WindowsUpdatesByDeviceResponse } from '../models/windows-updates-by-device-response';

const useDeviceInstalledWindowsUpdates = (
  deviceId: string,
  skip = false
): {
  data?: WindowsUpdatesByDeviceResponse;
  error?: Error;
  mutate: KeyedMutator<WindowsUpdatesByDeviceResponse>;
  isLoading: boolean;
} => {
  return useSwr(!skip ? [deviceId, 'WindowsUpdatesService', 'getDeviceInstalledOsUpdates'] : null, ([deviceId]) => {
    return windowsUpdatesService.getDeviceInstalledOsUpdates(deviceId);
  });
};

export default useDeviceInstalledWindowsUpdates;
